import { useState } from 'react';

const faqs = [
  {
    q: '羞羞歪歪漫画需要付费吗？',
    a: '完全不需要！羞羞歪歪漫画所有内容均为免费全集无删减，无需注册登录即可畅享全部漫画资源。我们坚持免费理念，让每一位漫画爱好者都能无门槛享受阅读乐趣。',
  },
  {
    q: '什么是在线下拉式阅读？',
    a: '下拉式阅读是一种创新的漫画阅读体验模式。与传统的左右翻页不同，下拉式阅读让漫画内容以上下连续滚动的方式呈现，您只需向下滑动屏幕即可流畅阅读，无需频繁点击翻页按钮，阅读体验更加沉浸和高效。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '我们与各大漫画平台保持同步更新节奏。热门作品通常每周更新一话，具体更新日期取决于原作连载进度。您可以关注首页的"最近更新"栏目，随时掌握最新动态。',
  },
  {
    q: '可以在手机上阅读吗？',
    a: '当然可以！羞羞歪歪漫画采用响应式网页设计，完美适配手机、平板和电脑等各类设备。只需通过手机浏览器访问我们的入口官网，即可随时随地享受流畅的漫画阅读体验，无需下载任何APP。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">关于羞羞歪歪漫画的常见疑问解答</p>
        </div>

        <div className="max-w-[720px] mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer bg-transparent border-0"
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">{faq.q}</h3>
                <span className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'bg-primary-100 text-primary-600 rotate-180' : 'bg-background-200 text-foreground-500'}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${openIdx === idx ? 'max-h-[300px] pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'}`}
              >
                <p className="text-sm text-foreground-700 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}